<template>
  <v-card
    color="grey lighten-3 mt-3"
    padless dimgray
  >
  <div v-show="wideWidth()">
    <v-row class="px-4">

      <v-col
        class="py-4"
        cols="3"
      >
        <v-card-text class="px-5">
          <strong>サービス</strong><br/>
          <div
          v-for="item in service"
          :key="item.name"
          class="border"
          >
            <a v-if="item.external_link" :href="item.href" class="blue-grey--text">{{ item.name }}</a>
            <router-link v-if="!item.external_link" :to="item.href" class="blue-grey--text">
              {{ item.name }}<br/>
            </router-link>
          </div>
        </v-card-text>
      </v-col>

      <v-col
        class="py-4"
        cols="3"
      >
        <v-card-text class="px-5">
          <strong>製品案内</strong><br/>
          <div
          v-for="item in products"
          :key="item.name"
          class="border">
          <router-link :to="item.href" class="blue-grey--text">
            {{ item.name }}<br/>
          </router-link>
          </div>
        </v-card-text>
      </v-col>

      <v-col
        class="py-4"
        cols="3"
      >
        <v-card-text class="px-5">
          <div
          v-for="item in links"
          :key="item.name"
          class="border"
          >
          <router-link :to="item.href" class="blue-grey--text">
            {{ item.name }}<br/>
          </router-link>
          </div>
        </v-card-text>
      </v-col>

      <v-col
        class="py-4"
        cols="3"
      >
        <v-card-text class="px-5 text-center">
          <strong>有限会社コニーシステム&emsp;&emsp;</strong>
          <v-btn icon to="https://www.facebook.com/konniesystem/">
            <v-icon color="#3b5998">mdi-facebook-box</v-icon>
          </v-btn><br/>
          〒770-0936<br>
          徳島県徳島市中央通3丁目１番地<br>
          電話番号  : 088-625-8102<br>
          FAX番号  : 088-625-8104<br>
          <a href="https://www.facebook.com/konniesystem/" target=_blank title="コニーシステムfacebookページへ"><v-icon large color="light-blue darken-3">mdi-facebook</v-icon></a>
        </v-card-text>
      </v-col>
    </v-row>

    <v-divider></v-divider>
  </div>
  <v-col>
      <v-layout justify-center>
      <router-link to="/Sitemap" class="blue-grey--text">サイトマップ</router-link>・
      <router-link to="/Privacy" class="blue-grey--text">プライバシーポリシー</router-link>
    </v-layout>
    </v-col>
    <v-col
    class="py-1"
    cols="12"
    >
      <v-card-text class="text-center">
        &copy;{{ new Date().getFullYear() }} — <span>Konniesystem Co.,Ltd.</span>
      </v-card-text>
    </v-col>
  </v-card>
</template>

<style>
.border {
  border-left: solid #444444;
  padding-left: 10px;
}
</style>

<script>
export default {
  data: () => ({
    // リサイズイベント用 初期値0
    windowWidth: 0,
    // ウィジェットリスト
    service: [
      {
        name: 'ホームページ運用保守',
        href: '/hp_maintenance/',
        external_link: true
      },
      {
        name: 'システム運用保守',
        href: '/Service/Maintenance/',
        external_link: true
      },
      {
        name: '学会サポート',
        href: '/Service/supportConference/',
        external_link: false
      },
      {
        name: '学術研究機関向けサイト作成',
        href: '/Service/academicSite',
        external_link: false
      },
      {
        name: 'OSS製品のサポート',
        href: '/Service/supportOSS',
        external_link: false
      },
      {
        name: '受託開発',
        href: '/Service/Commissioned',
        external_link: false
      },
      {
        name: '研究開発',
        href: '/Service/Investigation',
        external_link: false
      }
    ],
    products: [
      {
        name: '全文検索システム',
        href: '/Products/Search'
      },
      {
        name: 'e-Learningシステム',
        href: '/Products/Elearning'
      },
      {
        name: '歯科予約システム',
        href: '/Products/reserveDental'
      },
      {
        name: '診療予約システム',
        href: '/Products/reserveMedical'
      },
      {
        name: '学術集会向けオンライン演題登録/査読システム',
        href: '/Products/registration'
      },
      {
        name: '学術集会向け事前参加登録システム',
        href: '/Products/participation'
      }
    ],
    links: [
      {
        name: '会社情報',
        href: '/Company'
      },
      {
        name: 'お問い合わせ',
        href: 'Contact'
      }
      // ,
      // {
      //   name: 'サイトマップ',
      //   href: '/Sitemap'
      // },
      // {
      //   name: 'プライバシーポリシー',
      //   href: 'Privacy'
      // }
    ]
  }),
  // DOMを作成
  mounted () {
    window.addEventListener('resize', this.wideWidth)
    window.addEventListener('load', this.wideWidth)
  },
  // リサイズイベントの実行
  beforeDestroy () {
    window.addEventListener('resize', this.wideWidth)
  },
  methods: {
    // 画面幅を特定
    wideWidth () {
      this.windowWidth = window.innerWidth
      if (this.windowWidth > 900) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
